export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/profile-public/index.js